import { useState } from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineChevronDown, HiOutlineChevronUp } from "react-icons/hi";

function CurrencyNavbarComponent() {
  const [openMenuCurrency, setOpenMenuCurrency] = useState<boolean>(false);
  const [currencyCheck, setCurrencyCheck] = useState<string>("SR");
  const { t } = useTranslation();

  function changeIconOfCurrency() {
    if (localStorage.getItem("currency") === "USD") {
      return "/assets/images/us-icon.png";
    } else if (localStorage.getItem("currency") === "EUR") {
      return "/assets/images/uk-icon.png";
    } else {
      return "/assets/images/sa-icon.png";
    }
  }

  return (
    <div className="relative mobile:hidden">
      <button
        onClick={() => {
          setOpenMenuCurrency(!openMenuCurrency);
        }}
        className="flex flex-row gap-1 items-center justify-center border border-tart-500 rounded-xl h-11 w-20"
      >
        <img alt="" src={changeIconOfCurrency()} className="h-6 w-6"></img>
        {openMenuCurrency ? (
          <HiOutlineChevronUp size={20.59} className="text-tart-500" />
        ) : (
          <HiOutlineChevronDown size={20.59} className="text-tart-500" />
        )}
      </button>
      {openMenuCurrency && (
        <div className="absolute mt-2.5 z-50 w-[135px] py-2.5 h-fit rounded-xl bg-zinc-50 animate-fade animate-once animate-duration-300 animate-delay-100 animate-ease-out animate-normal drop-shadow-[0_0px_10px_rgba(0,0,0,0.05)]">
          <div className="flex flex-col gap-3 font-arLight text-neutral800 text-sm animate-flip-down animate-once animate-duration-300 animate-ease-out animate-normal">
            <div className="px-2 border-b-[0.5px] border-[#E5E5E5]">
              {t("app.shared.currency")}
            </div>
            <div
              onClick={() => {
                setCurrencyCheck("SR");
                localStorage.setItem("currency", "SR");
                setOpenMenuCurrency(false);
              }}
              className={`flex ${
                currencyCheck === "SR" ? "bg-mint-500 text-zinc50" : ""
              } gap-1 items-center h-8 px-1 cursor-pointer`}
            >
              <img
                alt=""
                src="/assets/images/sa-icon.png"
                className="h-6 w-6"
              ></img>
              {t("menuOfNavbar.component.saudiRiyal")}
            </div>
            <div
              onClick={() => {
                setCurrencyCheck("EUR");
                localStorage.setItem("currency", "EUR");
                setOpenMenuCurrency(false);
              }}
              className={`flex ${
                currencyCheck === "EUR" ? "bg-mint-500 text-zinc50" : ""
              } gap-1 items-center h-8 px-1 cursor-pointer`}
            >
              <img
                alt=""
                src="/assets/images/uk-icon.png"
                className="h-6 w-6"
              ></img>
              {t("menuOfNavbar.component.euro")}
            </div>
            <div
              onClick={() => {
                setCurrencyCheck("USD");
                localStorage.setItem("currency", "USD");
                setOpenMenuCurrency(false);
              }}
              className={`flex ${
                currencyCheck === "USD" ? "bg-mint-500 text-zinc50" : ""
              } gap-1 items-center h-8 px-1 cursor-pointer`}
            >
              <img
                alt=""
                src="/assets/images/us-icon.png"
                className="h-6 w-6"
              ></img>
              {t("menuOfNavbar.component.americanDollar")}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CurrencyNavbarComponent;
